import type { ConsentementLegacy } from "@types"

/**
 * Clé du bus VueUse `useEventBus` pour recharger la liste des demandes de consentement
 * (ex. après prolongement ou changement de titulaire depuis le tableau des consentements).
 */
export const CONSENT_REQUESTS_RELOAD_BUS_KEY = "consent-requests:reload"

/**
 * Clé du bus VueUse `useEventBus` pour recharger listes consentements **et** demandes
 * après la fin du parcours d’ajout multi (`SourceMultiAppendDialog`) sur la page consentements.
 */
export const CONSENT_PAGE_AFTER_SOURCE_MULTI_APPEND_BUS_KEY =
    "consent-page:reload-after-source-multi-append"

/** Durée par défaut (mois) alignée sur {@link SourceExtendDialog} / `SourceConsentSign` prolongement. */
export const CONSENT_EXTEND_DEFAULT_MONTHS = 60

/**
 * Champs consentement exploitables depuis la réponse API PUT extend (fusion liste locale).
 */
export type ConsentExtendListPatchFields = Partial<
    Pick<
        ConsentementLegacy,
        | "_id"
        | "date_to"
        | "date_from"
        | "date_from_data"
        | "signed_at"
        | "updatedAt"
        | "dismissed"
        | "dismissed_at"
        | "signed"
        | "createdAt"
    >
>

export type ConsentListPatchRevoked = {
    kind: "revoked"
    consentId: string
}

export type ConsentListPatchExtendSigned = {
    kind: "extend_signed"
    /** `_id` de la ligne prolongée (avant création du nouveau document côté API). */
    previousConsentId: string
    /** Nouvel identifiant consentement renvoyé par l’API. */
    newConsentId?: string
    fields?: ConsentExtendListPatchFields
}

export type ConsentListPatch =
    | ConsentListPatchRevoked
    | ConsentListPatchExtendSigned

/**
 * Extrait les champs fusionnables depuis `consentement` dans la réponse consent request (populate API).
 */
export function pickConsentExtendFieldsFromApiResponse(
    consentement: unknown
): ConsentExtendListPatchFields | undefined {
    if (!consentement || typeof consentement !== "object") return undefined
    const o = consentement as Record<string, unknown>
    const out: ConsentExtendListPatchFields = {}
    if (o._id != null) out._id = String(o._id)
    for (const key of [
        "date_to",
        "date_from",
        "date_from_data",
        "signed_at",
        "updatedAt",
        "dismissed_at",
        "createdAt",
    ] as const) {
        const v = o[key]
        if (typeof v === "string") out[key] = v
    }
    if (typeof o.dismissed === "boolean") out.dismissed = o.dismissed
    if (typeof o.signed === "boolean") out.signed = o.signed
    return Object.keys(out).length ? out : undefined
}
